module.exports = __webpack_public_path__ + "img/102.21b98406.png";